import { RiStarFill, RiArrowLeftSLine, RiArrowRightSLine } from "@remixicon/react"
import { useState, useEffect } from "react"

export default function CharlestonTestimonials() {
  const [currentIndex, setCurrentIndex] = useState(0)
  const [isAutoPlaying, setIsAutoPlaying] = useState(true)

  const testimonials = [
    {
      name: "Sarah Mitchell",
      business: "The Gourmet Kitchen",
      location: "Charleston, SC",
      text: "Our online orders increased 300%. Best investment we've made!",
      rating: 5,
      image: "https://ui-avatars.com/api/?name=Sarah+Mitchell&background=003566&color=fff&size=128&bold=true",
    },
    {
      name: "Marcus Johnson",
      business: "Palmetto Construction",
      location: "Mount Pleasant, SC",
      text: "First page of Google for all our services. The leads keep coming in.",
      rating: 5,
      image: "https://ui-avatars.com/api/?name=Marcus+Johnson&background=001d3d&color=fff&size=128&bold=true",
    },
    {
      name: "Emily Rodriguez",
      business: "Coastal Beauty Spa",
      location: "Charleston, SC",
      text: "Instagram following tripled. Booking weeks in advance now!",
      rating: 5,
      image: "https://ui-avatars.com/api/?name=Emily+Rodriguez&background=000814&color=fff&size=128&bold=true",
    },
    {
      name: "David Chen",
      business: "Charleston Tech Solutions",
      location: "Charleston, SC",
      text: "Website traffic doubled in just three months. Highly recommend!",
      rating: 5,
      image: "https://ui-avatars.com/api/?name=David+Chen&background=003566&color=fff&size=128&bold=true",
    },
    {
      name: "Jennifer Walsh",
      business: "Lowcountry Realty Group",
      location: "Charleston, SC",
      text: "Property listings get significantly more views. They understand our local market.",
      rating: 5,
      image: "https://ui-avatars.com/api/?name=Jennifer+Walsh&background=001d3d&color=fff&size=128&bold=true",
    },
    {
      name: "Robert Taylor",
      business: "Harbor View Restaurant",
      location: "Folly Beach, SC",
      text: "Reservations up 250%. Our brand recognition has skyrocketed.",
      rating: 5,
      image: "https://ui-avatars.com/api/?name=Robert+Taylor&background=000814&color=fff&size=128&bold=true",
    },
    {
      name: "Lisa Anderson",
      business: "Charleston Fitness Studio",
      location: "North Charleston, SC",
      text: "Brought in exactly the clients we wanted. Measurable results every month!",
      rating: 5,
      image: "https://ui-avatars.com/api/?name=Lisa+Anderson&background=003566&color=fff&size=128&bold=true",
    },
    {
      name: "Michael Brennan",
      business: "Coastal Auto Group",
      location: "Summerville, SC",
      text: "Online presence has never been stronger. Showroom traffic is way up!",
      rating: 5,
      image: "https://ui-avatars.com/api/?name=Michael+Brennan&background=001d3d&color=fff&size=128&bold=true",
    },
    {
      name: "Amanda Foster",
      business: "Foster Law Firm",
      location: "Charleston, SC",
      text: "Quality leads increased by 200%. Professional service that delivers.",
      rating: 5,
      image: "https://ui-avatars.com/api/?name=Amanda+Foster&background=000814&color=fff&size=128&bold=true",
    },
    {
      name: "James Martinez",
      business: "Charleston HVAC Pro",
      location: "West Ashley, SC",
      text: "Phone rings constantly now. Couldn't be happier with the results!",
      rating: 5,
      image: "https://ui-avatars.com/api/?name=James+Martinez&background=003566&color=fff&size=128&bold=true",
    },
    {
      name: "Rachel Kim",
      business: "Boutique on King Street",
      location: "Charleston, SC",
      text: "Social media engagement through the roof. Sales have never been better.",
      rating: 5,
      image: "https://ui-avatars.com/api/?name=Rachel+Kim&background=001d3d&color=fff&size=128&bold=true",
    },
    {
      name: "Tom Richardson",
      business: "Richardson Dental",
      location: "Mount Pleasant, SC",
      text: "New patient inquiries up 180%. They know what they're doing!",
      rating: 5,
      image: "https://ui-avatars.com/api/?name=Tom+Richardson&background=000814&color=fff&size=128&bold=true",
    },
  ]

  const nextSlide = () => {
    setCurrentIndex((prev) => (prev + 1) % testimonials.length)
  }

  const prevSlide = () => {
    setCurrentIndex((prev) => (prev - 1 + testimonials.length) % testimonials.length)
  }

  const goToSlide = (index: number) => {
    setCurrentIndex(index)
    setIsAutoPlaying(false)
  }

  useEffect(() => {
    if (!isAutoPlaying) return

    const interval = setInterval(() => {
      nextSlide()
    }, 5000)

    return () => clearInterval(interval)
  }, [currentIndex, isAutoPlaying])

  return (
    <section
      aria-label="Client Testimonials"
      id="testimonials"
      className="relative mx-auto max-w-7xl px-4 scroll-my-24"
    >
      <div className="text-center mb-16">
        <h2 className="relative inline-block text-lg font-semibold tracking-tight text-[#003566]">
          Client Success Stories
          <div className="absolute top-1 -left-[8px] h-5 w-[3px] rounded-r-sm bg-[#003566]" />
        </h2>
        <p className="mt-4 text-4xl font-semibold tracking-tighter text-balance text-gray-900 md:text-5xl">
          Trusted by Charleston's Finest
        </p>
        <p className="mt-4 text-lg text-balance text-gray-700 max-w-3xl mx-auto">
          Don't just take our word for it. See what local business owners have to say about working with us.
        </p>
      </div>

      {/* Slideshow Container */}
      <div className="relative max-w-4xl mx-auto">
        {/* Main Slideshow */}
        <div className="relative overflow-hidden rounded-3xl bg-gradient-to-br from-gray-50 to-white p-6 md:p-12 shadow-2xl border border-gray-100">
          <div className="relative min-h-[280px] md:min-h-[320px] flex items-center justify-center">
            {testimonials.map((testimonial, index) => (
              <div
                key={index}
                className={`absolute inset-0 transition-all duration-700 ease-in-out ${
                  index === currentIndex
                    ? 'opacity-100 translate-x-0 scale-100'
                    : index < currentIndex
                    ? 'opacity-0 -translate-x-full scale-95'
                    : 'opacity-0 translate-x-full scale-95'
                }`}
              >
                <div className="flex flex-col items-center justify-center h-full text-center px-4 md:px-16">
                  {/* Stars */}
                  <div className="flex gap-1 mb-6">
                    {[...Array(testimonial.rating)].map((_, i) => (
                      <RiStarFill key={i} className="size-5 md:size-6 text-[#ffc300] drop-shadow-md" />
                    ))}
                  </div>

                  {/* Testimonial Text */}
                  <blockquote className="text-xl md:text-2xl font-semibold text-gray-900 leading-relaxed mb-8 max-w-3xl">
                    "{testimonial.text}"
                  </blockquote>

                  {/* Author Info */}
                  <div className="flex flex-col items-center gap-3">
                    <div className="w-16 h-16 md:w-20 md:h-20 rounded-full overflow-hidden ring-4 ring-[#06b6d4]/30 shadow-xl">
                      <img
                        src={testimonial.image}
                        alt={testimonial.name}
                        className="w-full h-full object-cover"
                      />
                    </div>
                    <div>
                      <p className="font-bold text-lg md:text-xl text-gray-900">{testimonial.name}</p>
                      <p className="text-sm md:text-base text-gray-600 font-medium">{testimonial.business}</p>
                      <p className="text-xs md:text-sm text-gray-500">{testimonial.location}</p>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Navigation Arrows */}
          <button
            onClick={() => {
              prevSlide()
              setIsAutoPlaying(false)
            }}
            className="absolute left-2 md:left-4 top-1/2 -translate-y-1/2 p-3 md:p-4 rounded-full bg-white shadow-xl hover:shadow-2xl transition-all duration-200 hover:scale-110 border-2 border-gray-200 hover:border-[#06b6d4] group z-10"
            aria-label="Previous testimonial"
          >
            <RiArrowLeftSLine className="size-6 md:size-7 text-gray-700 group-hover:text-[#06b6d4] transition-colors" />
          </button>
          <button
            onClick={() => {
              nextSlide()
              setIsAutoPlaying(false)
            }}
            className="absolute right-2 md:right-4 top-1/2 -translate-y-1/2 p-3 md:p-4 rounded-full bg-white shadow-xl hover:shadow-2xl transition-all duration-200 hover:scale-110 border-2 border-gray-200 hover:border-[#06b6d4] group z-10"
            aria-label="Next testimonial"
          >
            <RiArrowRightSLine className="size-6 md:size-7 text-gray-700 group-hover:text-[#06b6d4] transition-colors" />
          </button>
        </div>

        {/* Slide Indicators */}
        <div className="flex justify-center gap-2 mt-8 flex-wrap px-4">
          {testimonials.map((_, index) => (
            <button
              key={index}
              onClick={() => goToSlide(index)}
              className={`transition-all duration-300 rounded-full ${
                index === currentIndex
                  ? 'w-12 h-3 bg-[#06b6d4] shadow-lg shadow-[#06b6d4]/40'
                  : 'w-3 h-3 bg-gray-300 hover:bg-gray-400'
              }`}
              aria-label={`Go to testimonial ${index + 1}`}
            />
          ))}
        </div>

        {/* Counter */}
        <div className="text-center mt-6">
          <p className="text-sm font-medium text-gray-600">
            {currentIndex + 1} of {testimonials.length}
          </p>
        </div>
      </div>
    </section>
  )
}
